import { validEmailRegex } from './user_form_helper';
import { StringConstantsMixin } from '../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const {
  strings: {
    GIFT_FLOW: {
      GIFT_CUSTOMIZE_FORM: { ENTER_AN_EMAIL, ENTER_A_NAME, ENTER_VALID_EMAIL, FIVE_HUNDRED_CHARACTERS_MAX }
    }
  }
} = StringConstantsMixin;

const validateGiftForm = (name, value) => {
  switch (name) {
    case 'recipientName':
    case 'senderName':
      return value.trim().length === 0 ? ENTER_A_NAME : '';
    case 'recipientEmail':
    case 'senderEmail':
      if (value.trim().length === 0) {
        return ENTER_AN_EMAIL;
      } else if (!validEmailRegex.test(value)) {
        return ENTER_VALID_EMAIL;
      }
    case 'message':
      return value.trim().length > 500 ? FIVE_HUNDRED_CHARACTERS_MAX : '';
    default:
      return '';
  }
};

const hasFormErrors = params => {
  let keys = Object.keys(params);

  if (params.sendMethod === 'print') {
    keys = keys.filter(k => k !== 'recipientEmail');
  }

  return keys.some(key => {
    return validateGiftForm(key, params[key]).length > 0;
  });
};

export { validateGiftForm, hasFormErrors };
